/**
 * Font stacks for Thai / Latin / mixed user-generated text (e.g. pet names).
 * Browsers pick the first font in the list that has a glyph for each character.
 */

/** Latin-first: English uses Gilroy; Thai falls back to Noto per character. */
export const FONT_STACK_MIXED_THAI_LATIN =
  '"Gilroy-Regular", "Gilroy", "Noto Sans Thai", "Noto Sans", system-ui, sans-serif';

/** Thai-first: Thai UI strings; Latin still renders via Noto Sans. */
export const FONT_STACK_THAI_PRIMARY =
  '"Noto Sans Thai", "Noto Sans", "Gilroy-Regular", "Gilroy", system-ui, sans-serif';

export const FONT_STACK_LATIN_ONLY =
  '"Gilroy-Regular", "Gilroy", system-ui, sans-serif';

const THAI_RE = /[\u0E00-\u0E7F]/;
/** Letters (not only ASCII) for mixed names, e.g. José, Müller */
const LATIN_LETTER_RE = /[A-Za-zÀ-ÿĀ-ž]/;

/**
 * @param {unknown} text
 * @returns {string} CSS font-family value
 * - English-only → Gilroy
 * - Thai-only → Noto Sans Thai stack (better metrics for Thai)
 * - Mixed → Gilroy first with Noto fallback (Latin in Gilroy, Thai in Noto)
 */
export function fontFamilyForMixedThaiLatin(text) {
  const s = String(text ?? '').normalize('NFC');
  if (!s.trim()) return FONT_STACK_LATIN_ONLY;
  const hasThai = THAI_RE.test(s);
  const hasLatin = LATIN_LETTER_RE.test(s);
  if (hasThai && hasLatin) return FONT_STACK_MIXED_THAI_LATIN;
  if (hasThai) return FONT_STACK_THAI_PRIMARY;
  return FONT_STACK_LATIN_ONLY;
}
